exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".color-chart[data-v-8b30a768]{margin-left:1em;margin-right:1em;background:#00f;background:-moz-linear-gradient(left,blue 25%,lime 55%,#fbff28 85%,red 100%);background:-webkit-linear-gradient(left,blue 25%,lime 55%,#fbff28 85%,red);background:linear-gradient(90deg,blue 25%,lime 55%,#fbff28 85%,red)}.color-chart-min[data-v-8b30a768]{color:#00f}.color-chart-max[data-v-8b30a768]{color:red}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-8b30a768","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/map/visualization/color_chart/congestion.vue
// module id = 816
// module chunks = 0